import { useContext } from "react";
import { AppContext } from "../App";
import AboutUsLanding from "../views/AboutUsLanding";

export default function AboutUs() {
  const appContext = useContext(AppContext);

  if (
    !appContext.navSubItem &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <AboutUsLanding />;
  }

  return null;
}
